import { Period } from '@root/shared/period'

import type { TransKey } from '@root/shared/localization'

export enum UserTradingAnalyticsPeriod {
  ALL = 'ALL::UserTradingAnalyticsPeriod',
  '1H' = '1H::UserTradingAnalyticsPeriod',
  '6H' = '6H::UserTradingAnalyticsPeriod',
  '12H' = '12H::UserTradingAnalyticsPeriod',
  '1D' = '1D::UserTradingAnalyticsPeriod',
  '7D' = '7D::UserTradingAnalyticsPeriod',
}
export const USER_TRADING_ANALYTICS_PERIODS = [
  UserTradingAnalyticsPeriod['1H'],
  UserTradingAnalyticsPeriod['6H'],
  UserTradingAnalyticsPeriod['12H'],
  UserTradingAnalyticsPeriod['1D'],
  UserTradingAnalyticsPeriod['7D'],
  UserTradingAnalyticsPeriod.ALL,
] as const

export const USER_TRADING_ANALYTICS_PERIOD_LABEL_MAP: Record<
  UserTradingAnalyticsPeriod,
  TransKey
> = {
  [UserTradingAnalyticsPeriod.ALL]: Period.PERIOD_LABEL_MAP.ALL,
  [UserTradingAnalyticsPeriod['1H']]: Period.PERIOD_LABEL_MAP['1H'],
  [UserTradingAnalyticsPeriod['6H']]: Period.PERIOD_LABEL_MAP['6H'],
  [UserTradingAnalyticsPeriod['12H']]: Period.PERIOD_LABEL_MAP['12H'],
  [UserTradingAnalyticsPeriod['1D']]: Period.PERIOD_LABEL_MAP['24H'],
  [UserTradingAnalyticsPeriod['7D']]: Period.PERIOD_LABEL_MAP['7D'],
}
